var map = {
	"./goldcoin/task-detail-bg.jpg": 31240,
	"./memetown/task-detail-bg.jpg": 98531,
	"./reflection/task-detail-bg.jpg": 39844,
	"./tapcoin/task-detail-bg.jpg": 68183
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33358;